import React from 'react'
import Text from '@/stories/components/Common/NewText'

const InStockL2Heading = ({
  heading,
  subheading,
}: {
  heading?: string
  subheading?: string | null
}) => {
  return (
    <div className="mb-6 flex w-full flex-col gap-1 border-b-[0.5px] pb-6">
      {heading && (
        <Text appearance="heading2" tag="h2">
          {heading}
        </Text>
      )}

      {subheading && (
        <Text appearance="caption" addClassName="text-brand-grey-base">
          {subheading}
        </Text>
      )}
    </div>
  )
}

export default InStockL2Heading
